import type { TenantTables } from '@dcp/shared/types/tenant-database'
import type { Facility } from '@/types/banking'

type FacilityRow = TenantTables['facilities']['Row']

/** A `facilities` row as the UI's {@link Facility}. */
export function toFacility(row: FacilityRow): Facility {
  return {
    id: row.id,
    name: row.name,
    legal_name: row.legal_name,
    code: row.code || '',
    sage_location_id: row.sage_location_id || null,
    is_active: row.is_active,
    pack_id: row.pack_id,
    // Narrow the DB's free-form `source: string` (DCP-262) to the
    // FacilitySource union: anything other than the explicit 'sage_intacct'
    // marker collapses to 'manual', matching the DB column default.
    source: row.source === 'sage_intacct' ? 'sage_intacct' : 'manual',
  }
}
